import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { Transform } from "@mui/icons-material";

/**
 * Set Node Avancado — Mapear/transformar campos com multiplas operacoes.
 *
 * data.operations: [
 *   { target: string, source: string, transform?: string }
 * ]
 * data.operations[].transform: "none" | "uppercase" | "lowercase" | "trim" |
 *   "parseInt" | "parseFloat" | "substring" | "replace" | "split" | "jsonParse"
 */
const SetAdvancedNode = memo(({ id, data, isConnectable, selected }) => {
  const operations = data?.operations || [];

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Transform />}
      title="Set Avancado"
      color="#1565C0"
      bgColor="#E3F2FD"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {operations.length === 0 ? (
          <div style={{ fontSize: 11, color: "#999", fontStyle: "italic" }}>
            Nenhuma operacao configurada
          </div>
        ) : (
          operations.slice(0, 4).map((op, i) => (
            <div key={i} style={{
              background: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: 4,
              padding: "3px 8px",
              fontSize: 11,
              fontFamily: "'Fira Code', monospace",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}>
              <span style={{ color: "#1565C0", fontWeight: 600 }}>
                {op.target || "?"}
              </span>
              <span style={{ color: "#999" }}>{"="}</span>
              <span style={{ color: "#C62828", fontWeight: 600 }}>
                {op.source || "?"}
              </span>
              {op.transform && op.transform !== "none" && (
                <span style={{
                  color: "#fff", background: "#7B1FA2",
                  borderRadius: 3, padding: "0 4px",
                  fontSize: 8, fontWeight: 700,
                }}>
                  {op.transform}
                </span>
              )}
            </div>
          ))
        )}
        {operations.length > 4 && (
          <div style={{ fontSize: 10, color: "#999" }}>
            +{operations.length - 4} operacao(oes)
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});

SetAdvancedNode.displayName = "SetAdvancedNode";
export default SetAdvancedNode;
